import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, TextField, Button, Stack } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const SubCategoryModal = ({ open, onClose, categoryId, categoryName, onSubmit }) => {
  const [subCategoryName, setSubCategoryName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setSubCategoryName("");
      setError("");
    }
  }, [open]);

  const handleSubmit = () => {
    if (!subCategoryName.trim()) {
      setError("Subcategory name is required");
      return;
    }

    // Pass both category_id and subcategory name
    onSubmit({
      category_id: categoryId,
      name: subCategoryName.trim(),
    });

    setSubCategoryName("");
    setError("");
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Add Subcategory
        </Typography>

        <TextField
          label="Category Name"
          value={categoryName}
          fullWidth
          size="small"
          disabled
          sx={{ mb: 2 }}
        />

        <TextField
          label="Subcategory Name"
          value={subCategoryName}
          onChange={(e) => {
            setSubCategoryName(e.target.value);
            if (error) setError("");
          }}
          fullWidth
          size="small"
          sx={{ mb: 3 }}
          error={!!error}
          helperText={error}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default SubCategoryModal;
